import React from "react";
import FormattedDate from "./FormattedDate";
import WeatherIcon from "./WeatherIcon";
import WeatherTemperature from "./WeatherTemperature";

import "./WeatherInfo.css";

export default function WeatherInfo(props) {
  return (
    <div className="WeatherInfo">
      <div className="first">
        <span>
          <i className="fa-solid fa-location-dot"></i>{" "}
          <span className="city">{props.data.city}</span>
        </span>
        <div className="date">
          <FormattedDate date={props.data.date} />
        </div>
      </div>
      <div className="row">
        <div className="col second">
          <span className="icon">
            <WeatherIcon code={props.data.icon} />
          </span>
        </div>
        <div className="col third">
          <WeatherTemperature celsius={props.data.temperature} />
          <div className="icon-name">{props.data.description}</div>
        </div>
        <div className="col fourth">
          <span className="data">
            <div>
              <i className="fa-solid fa-temperature-high"></i> Max:
              <span className="maxTemp"> {props.data.maxTemperature} ℃</span>
            </div>
            <div>
              <i className="fa-solid fa-temperature-low"></i> Min:
              <span className="minTemp"> {props.data.minTemperature} ℃</span>
            </div>
            <div>
              <i className="fa-solid fa-droplet"></i> Humidity:
              <span className="humidity"> {props.data.humidity} %</span>
            </div>
            <div>
              <i className="fa-solid fa-wind"></i> Wind:
              <span className="wind"> {props.data.wind} km/h</span>
            </div>
          </span>
        </div>
      </div>
    </div>
  );
}
